import { gql } from "@apollo/client";

export const GET_DEVICE_INFO = gql`
  query DeviceInfo($domain: String!, $input: BasicQueryInfoInput!) {
    device {
      info(domain: $domain, input: $input) {
        device_id
        name
        system_assignment
        lan_controller_id
        cpu_id
        power_supply
        max_ac_ports
      }
    }
  }
`

export interface DeviceInfo {
  device_id: number;
  name: string
  system_assignment?: number;
  cpu_id?: string;
  lan_controller_id?: number;
  power_supply: number;
  max_ac_ports: number;
}

export interface DeviceInfoResponse {
  device: {info: DeviceInfo[]}
}